// Dependencies
import React, { Component } from 'react';

// Primereact imports
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Styling
import './levantamento-suspensao.scss';

// Utils
import { PRODUCT_KEY_MESSAGE, PRODUCT_KEY_SUSPENSION_END_DATE } from '../../../common/constants';

// Redux
import { updateBasket } from '../../../redux/actions/order';
import { connect } from 'react-redux';

class LevantamentoSuspensaoComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            closeSuspensionDate: null,
            validCloseSuspensionDate: true
        }
    }

    updateFormComponent(column, value) {
        this.setState({
            [column]: value
        })
    }

    submitAcquisition() {
        if(this.validateForm()) {
            let metadata = [
                { key: PRODUCT_KEY_SUSPENSION_END_DATE, value: this.state.closeSuspensionDate },
                { key: PRODUCT_KEY_MESSAGE, value: this.buildTicketMessage() },
            ];

            // Add product to basket
            let product = this.props.product;
            product.metadata = metadata;

            let products = [];

            for (let i = 0; i < this.props.basketProducts.length; i++) {
                products.push(this.props.basketProducts[i]);
                
            }

            products.push(product);

            this.props.updateBasket(products, this.props.basketTrainings);
            this.props.onClose();
        }
    }

    validateForm() {
        this.setState({
            validCloseSuspensionDate: this.state.closeSuspensionDate !== null
        });

        let validationResult = (this.state.closeSuspensionDate !== null);

        return validationResult;
    }

    buildTicketMessage() {

        // Build full address
        var address = "";

        if(this.props.associate.personalData.streetTypePlaceholder !== null) {
            address += this.props.associate.personalData.streetTypePlaceholder;
        }

        if(this.props.associate.personalData.addressLine !== null) {
            address += " " + this.props.associate.personalData.addressLine;
        }

        if(this.props.associate.personalData.doorNumber !== null) {
            address += " " + this.props.associate.personalData.doorNumber;
        }

        if(this.props.associate.personalData.doorFloor !== null) {
            address += " " + this.props.associate.personalData.doorFloor;
        }

        var dd = String(this.state.closeSuspensionDate.getDate()).padStart(2, '0');
        var mm = String(this.state.closeSuspensionDate.getMonth() + 1).padStart(2, '0');
        var yyyy = this.state.closeSuspensionDate.getFullYear();
        
        return this.props.t("support.form.close-suspension-message-part-1") + this.props.associate.personalData.name + this.props.t("support.form.close-suspension-message-part-2") + this.props.associate.personalData.identificationNumber + this.props.t("support.form.close-suspension-message-part-3") + this.props.associate.personalData.nif + this.props.t("support.form.close-suspension-message-part-4") + address + " " + this.props.associate.personalData.cP4 + "-" + this.props.associate.personalData.cP3 + " " + this.props.associate.personalData.city + this.props.t("support.form.close-suspension-message-part-5") + this.props.ballot.ballotRef + this.props.t("support.form.close-suspension-message-part-6") + dd + '/' + mm + '/' + yyyy + this.props.t("support.form.close-suspension-message-part-7");
    }

    render() {
        return (
            <div className="grid mgt-10">
                <div className="col-12" style={{fontSize: "14px"}}>
                    <b>{this.props.t("products.labels.info-note")}</b>
                </div>
                <div className="col-12">
                    <div className="flex flex-column gap-2">
                        <label htmlFor="professional-name">{this.props.t("products.labels.suspension-end-date")}</label>
                        <Calendar dateFormat="dd/mm/yy" minDate={new Date()} value={this.state.closeSuspensionDate} showIcon showButtonBar onChange={(evt) => this.updateFormComponent("closeSuspensionDate", evt.target.value)} />
                        { this.state.validCloseSuspensionDate ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                    </div>
                </div>
                <div className='col-12 t-align-right'>
                    <div className="flex flex-wrap justify-content-end gap-2">
                        <Button label={this.props.t("products.labels.add")} icon="pi pi-shopping-cart" onClick={(evt) => this.submitAcquisition() }/>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        basketProducts: state.store.basketProducts,
        basketTrainings: state.store.basketTrainings
    } 
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateBasket: (basketProducts, basketTrainings) => { dispatch(updateBasket(basketProducts, basketTrainings)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(LevantamentoSuspensaoComponent));